import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import { UpdateCardAction } from '../model/cardActions';
import axios from 'axios';
import NoContentFound from '../../default/not-found/notFound';
import { ShimmerTable } from 'react-shimmer-effects';
import { CountryDropdown } from 'react-country-region-selector';
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
const SettingsList = () => {
    const { id } = useParams();
    const [cardId, setCardId] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const dispatch = useDispatch();

    const cardSettings = useSelector((state) => state.cardData);
    const userSettings = useSelector((state) => state.userData);
    const { data } = cardSettings;
    const [cardData, setMatchedData] = useState(null);
    const settings = cardData?.settings || '';
    useEffect(() => {
        setCardId(id);
        const fetchCardData = async () => {
            if (data && data.length > 0) {
                const foundData = data.find(item => item.ID === id);
                if (foundData) {
                    setMatchedData(foundData);
                    setIsLoading(false)
                } else {
                    try {
                        const response = await axios.get(`card/list/?cardID=${id}`);
                        if (response.data && response.data.data && response.data.data.length > 0) {
                            setMatchedData(response.data.data[0]);
                            setIsLoading(false)
                        } else {
                            setMatchedData(null);
                            setIsLoading(false)
                        }
                    } catch (error) {
                        console.error('Error fetching card data:', error);
                        setMatchedData(null);
                        setIsLoading(false)
                    }
                }
            } else {
                try {
                    const response = await axios.get(`card/list/?cardID=${id}`);
                    if (response.data && response.data.data && response.data.data.length > 0) {
                        setMatchedData(response.data.data[0]);
                        setIsLoading(false)
                    } else {
                        setMatchedData(null);
                        setIsLoading(false)
                    }
                } catch (error) {
                    console.error('Error fetching card data:', error);
                    setMatchedData(null);
                    setIsLoading(false)
                }
            }
        };

        fetchCardData();
    }, [id]);

    const [formData, setFormData] = useState({
        customID: '',
        domain: '',
        settings: {
            seoStatus: '',
            webViewStatus: '',
            templateStatus: '',
            country: '',
            leadFormTitle: '',
            leadForm: '',
            guestInfoRequired: '',
            notificationStatus: '',
            cardViewNotification: '',
            cardActivityNotification: '',
        },
        sharingMessage: {
            subject: '',
            message: ''
        }
    });


    useEffect(() => {

        const fetchData = async () => {
            if (data) {
                const fetchedData = {
                    customID: cardData?.customID,
                    domain: cardData?.domain,
                    settings: {
                        seoStatus: settings.seoStatus,
                        webViewStatus: settings.webViewStatus,
                        templateStatus: settings.templateStatus,
                        country: settings.country,
                        leadFormTitle: settings.leadFormTitle,
                        leadForm: settings.leadForm,
                        guestInfoRequired: settings.guestInfoRequired,
                        notificationStatus: settings.notificationStatus,
                        cardViewNotification: settings.cardViewNotification,
                        cardActivityNotification: settings.cardActivityNotification,
                    },
                    sharingMessage: {
                        subject: settings.shareMessage?.subject,
                        message: settings.shareMessage?.message,
                    }
                };
                setFormData(fetchedData);
            }
        };

        fetchData();
    }, [cardData, cardId]);


    const handleChange = (e) => {
        
        const value = e?.target ? e.target.value : e;
        const name = e?.target ? e.target.name : 'country';
    
        if (name === 'subject' || name === 'message') {
            setFormData(prev => ({
                ...prev,
                sharingMessage: {
                    ...prev.sharingMessage,
                    [name]: value
                }
            }));
        } else if (e?.target?.type === 'checkbox') {
            setFormData(prev => ({
                ...prev,
                settings: {
                    ...prev.settings,
                    [name]: e.target.checked ? "1" : "0"
                }
            }));
        } else if (name === 'guestInfoRequired') { 
            setFormData(prev => ({
                ...prev,
                settings: {
                    ...prev.settings,
                    [name]: value
                }
            }));
        } else if (name === 'country') {
            setFormData(prev => ({
                ...prev,
                settings: {
                    ...prev.settings,
                    [name]: value
                }
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };



    const handleSubmit = (e) => {
        e.preventDefault();
        const updatedFields = {};

        if (!cardData) {
            console.error('Card data is not available.');
            return;
        }

        const userSettings = cardData.settings || {};
        const userSharingMessage = cardData.settings?.shareMessage || {};

        for (const key in formData) {
            if (key === 'settings' || key === 'sharingMessage') {
                const changedData = {};
                let hasChanges = false;
                const userData = key === 'settings' ? userSettings : userSharingMessage;

                for (const nestedKey in formData[key]) {
                    const formValue = formData[key][nestedKey];
                    const userValue = key === 'sharingMessage' ?
                        userSharingMessage[nestedKey] :
                        userData[nestedKey];

                    if (formValue !== userValue && formValue !== '' && formValue !== undefined) {
                        changedData[nestedKey] = formValue;
                        hasChanges = true;
                    }
                }

                if (hasChanges) {
                    updatedFields[key] = changedData;
                }
            } else {
                const formValue = formData[key];
                const userValue = cardData[key];

                if (formValue !== userValue && formValue !== '') {
                    updatedFields[key] = formValue;
                }
            }
        }

        // Additional validation for sharingMessage
        if (updatedFields.sharingMessage) {
            const formMsg = formData.sharingMessage;
            const userMsg = userSharingMessage;

            if (formMsg.subject === userMsg.subject && formMsg.message === userMsg.message) {
                delete updatedFields.sharingMessage;
            }
        }

        if (Object.keys(updatedFields).length > 0) {
            dispatch(UpdateCardAction({ ID: id, ...updatedFields }, id));

            // Update local cardData with new values
            setMatchedData(prev => ({
                ...prev,
                ...updatedFields,
                settings: {
                    ...prev.settings,
                    ...(updatedFields.settings || {}),
                    shareMessage: {
                        ...prev.settings?.shareMessage,
                        ...(updatedFields.sharingMessage || {})
                    }
                }
            }));

            setErrorMessage('');
        } else {
            setErrorMessage('No changes detected. Please modify the fields before submitting.');
        }
    };
     // use id copy function
    const [copyMessage, setCopyMessage] = useState('Copy'); 
    const [copyIcon, setCopyIcon] = useState('');
     const handleCopy = async (CnameData) => {
        try {
            // Try modern clipboard API first
            if (navigator.clipboard) {
                await navigator.clipboard.writeText(CnameData);
                setCopyIcon('ri-check-double-line');
                setCopyMessage('Copied');
            } else {
                // Fallback for older browsers
                const textArea = document.createElement('textarea');
                textArea.value = CnameData;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                setCopyIcon('ri-check-double-line');
                setCopyMessage('Copied');
            }
        } catch (err) {
            console.error("Failed to copy: ", err);
            setCopyMessage("Failed to copy");
        } finally {
            // Reset the message after 2 seconds
            setTimeout(() => {
                setCopyMessage('Copy');
                setCopyIcon('');
            }, 2000);
        }
    };

    return (
        <>
            {cardData && isLoading === false ? (
                
                <form onSubmit={handleSubmit}>
                    <Tooltip
                        id="my-tooltip"
                        style={{background:'#717171'}}
                    />
                    <div className="settings-list-wrapper">
                        {userSettings.data?.isReseller === "1" ? (
                            <div className="single-settings">
                                <label className="setting-title">Agents only</label>
                                <div className="setting-content">
                                    <div className="sng-content-repeater">
                                        <div className="sng-content">
                                            <h5>Template status <i className="ri-information-2-line" data-tooltip-id="my-tooltip" data-tooltip-content="Template status"></i></h5>
                                            <p>Only you (honorable resellers) can enable any of your card as a template</p>
                                        </div>
                                        <div className="sng-toggle-button">
                                            <div className="pricing-switch">
                                                <label className="switch">
                                                    <input
                                                        id="allow-notification"
                                                        type="checkbox"
                                                        name="templateStatus"
                                                        status={formData.settings.templateStatus}
                                                        checked={formData.settings.templateStatus === '1' ? 1 : 0}
                                                        onChange={handleChange}
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ): ''}
                        <div className="single-settings">
                            <label className="setting-title">Privacy settings</label>
                            <div className="setting-content">
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <h5>Web view status <i className="ri-information-2-line" data-tooltip-id="my-tooltip" data-tooltip-content="Web view status"></i></h5>
                                        <p>Web view is unique feature of Cardiast that allows no-app user to view you digital business card directly from their web browser</p>
                                    </div>
                                   
                                    <div className="sng-toggle-button">
                                        <div className="pricing-switch">
                                            <label className="switch">
                                                <input
                                                    id="pricing-switch"
                                                    type="checkbox"
                                                    name="webViewStatus"
                                                    checked={formData.settings.webViewStatus === '1' ? 1 : 0}
                                                    onChange={handleChange}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <h5>SEO status <i className="ri-information-2-line" data-tooltip-id="my-tooltip" data-tooltip-content="SEO status"></i></h5>
                                        <p>With Card SEO, your Cardiast digital business card can be easily found by potential clients through search engines</p>
                                    </div>
                                    <div className="sng-toggle-button">
                                        <div className="pricing-switch">
                                            <label className="switch">
                                                <input
                                                    id="pricing-switch"
                                                    type="checkbox"
                                                    name="seoStatus"
                                                    status={formData.settings.seoStatus}
                                                    checked={formData.settings.seoStatus === '1' ? 1 : 0}
                                                    onChange={handleChange}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="single-settings">
                            <label className="setting-title">General</label>
                            <div className="setting-content">
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <h5>Custom card URL <i className="ri-information-2-line" data-tooltip-id="my-tooltip" data-tooltip-content="Custom card URL"></i></h5>
                                        <input
                                            className="sett-form-input"
                                            name="customID"
                                            value={formData.customID}
                                            onChange={handleChange}
                                            placeholder="https://cardiast.app/username_postfix"
                                        />
                                    </div>
                                </div>
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <h5>Custom domain <i className="ri-information-2-line" data-tooltip-id="my-tooltip" data-tooltip-content="Custom domain"></i></h5>
                                        <input
                                            className="sett-form-input"
                                            name="domain"
                                            value={formData.domain}
                                            onChange={handleChange}
                                            placeholder="company.com"
                                        />
                                        <div className="cName-wrapper">
                                            <p>-Add a new CNAME record from your DNS manager</p>
                                            <p>-CNAME: cd.cardiast.com 
                                            <span onClick={() => handleCopy(formData.cname)} className="copy-text">
                                                    <i className={copyIcon}></i> {copyMessage}
                                                </span>
                                                {/* <a className="copy-cName">COPY CNAME</a> */}
                                                </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <h5>Country: {formData.settings.country} <i className="ri-information-2-line" data-tooltip-id="my-tooltip" data-tooltip-content="Country"></i></h5>
                                        <CountryDropdown 
                                            value={formData.settings.country} 
                                            name="country"
                                            className="sett-form-input"
                                            onChange={handleChange}
                                            />
                                    </div>
                                </div>
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <h5>Sharing Message <i className="ri-information-2-line" data-tooltip-id="my-tooltip" data-tooltip-content="Sharing message"></i></h5>
                                        <input
                                            className="sett-form-input"
                                            name="subject"
                                            value={formData.sharingMessage?.subject || ''}
                                            onChange={handleChange}
                                            placeholder="Share subject" />
                                        <textarea
                                            className="sett-form-input sett-form-textarea"
                                            name="message"
                                            value={formData.sharingMessage?.message || ''}
                                            onChange={handleChange}
                                            placeholder="Share subject" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="single-settings">
                            <label className="setting-title">Lead/prospect capture from</label>
                            <div className="setting-content">
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <h5>Lead capture mode</h5>
                                        <p>lead collection from on your card</p>
                                    </div>
                                    <div className="sng-toggle-button">
                                        <div className="pricing-switch">
                                            <label className="switch">
                                                <input
                                                    id="pricing-switch"
                                                    type="checkbox"
                                                    checked={formData.settings.leadForm === '1' ? 1 : 0}
                                                    name="leadForm"
                                                    onChange={handleChange}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <h5>Lead capture</h5>
                                        <select
                                            className="sett-form-input"
                                            name="guestInfoRequired"
                                            value={formData.settings.guestInfoRequired || "0"}
                                            onChange={handleChange}
                                        >
                                            <option value="0">Optional</option>
                                            <option value="1">Required</option>
                                        </select>
                                        {/* <input className="sett-form-input" name="guestInfoRequired"  placeholder="Optional" /> */}
                                    </div>
                                </div>
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <h5>From title</h5>
                                        <input className="sett-form-input" name="leadFormTitle" value={settings.leadFormTitle} placeholder="Optional" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="single-settings">
                            <label className="setting-title">Push notifications</label>
                            <div className="setting-content">
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <h5>Allow notification</h5>
                                        <p>lead collection from on your card</p>
                                    </div>
                                    <div className="sng-toggle-button">
                                        <div className="pricing-switch">
                                            <label className="switch">
                                                <input
                                                    id="pricing-switch"
                                                    type="checkbox"
                                                    checked={formData.settings.notificationStatus === '1' ? 1 : 0}
                                                    name="notificationStatus"
                                                    onChange={handleChange}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <h5>View card</h5>
                                        <p>lead collection from on your card</p>
                                    </div>
                                    <div className="sng-toggle-button">
                                        <div className="pricing-switch">
                                            <label className="switch">
                                                <input
                                                    id="pricing-switch"
                                                    type="checkbox"
                                                    checked={formData.settings.cardViewNotification === '1' ? 1 : 0}
                                                    name="cardViewNotification"
                                                    onChange={handleChange}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <h5>Visitor activity on card</h5>
                                        <p>lead collection from on your card</p>
                                    </div>
                                    <div className="sng-toggle-button">
                                        <div className="pricing-switch">
                                            <label className="switch">
                                                <input
                                                    id="pricing-switch"
                                                    type="checkbox"
                                                    checked={formData.settings.cardActivityNotification === '1' ? 1 : 0}
                                                    name="cardActivityNotification"
                                                    onChange={handleChange}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="single-settings border-none">
                            <label className="setting-title">More actions</label>
                            <div className="setting-content">
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <h5>Your card ID: #{id}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="button-wrapper form-error-wrapper">
                            {errorMessage && <div className="error-message" style={{ color: 'red' }}>{errorMessage}</div>}
                            <button type="submit" className="btn submit-btn">Save updates</button>
                        </div>
                    </div>
                </form>
            ) : isLoading === false && (
                <NoContentFound title="Invalid card ID" />
            )}
            {isLoading &&
                <>
                    <ShimmerTable row={10} col={4} />
                </>
            }
        </>
    );
}

export default SettingsList;
